<script setup lang="ts">
import { useOrdersApi, TableOrders } from '@widgets/orders'
import { useOnTimezoneChange } from '@entities/viewer'
import { AppRoute } from '@shared/config'

defineOptions({
  name: 'OrdersListPage',
})

const route = useRoute()

onMounted(() => {
  void useOrdersApi()
})

// Filters, pagination and the sidebar link all navigate by query; refetching here keeps the table
// in sync with the URL, including a sidebar click while already on this page.
watch(() => route.query, () => {
  if (route.path === AppRoute.Orders) {
    void useOrdersApi()
  }
})

// Timestamps arrive pre-shifted into the admin's view timezone, so a timezone change needs a refetch.
useOnTimezoneChange(() => {
  void useOrdersApi()
})
</script>

<template>
  <TableOrders />
</template>
